import Head from 'next/head';

import { redirect, fetchOpts, baseUrlOf } from '../../../src/lib/ssr';
import PropTypes from 'prop-types';
import paymentMethodsApi from '../../../src/services/api/payment_methods';
import user from '../../../src/services/api/user';
import StripeAsyncProvider from '../../../src/components/subscribe/StripeAsyncProvider';
import { Elements } from 'react-stripe-elements';

import Link from 'next/link';
import Nav from '../../../src/components/profile/Nav';
import Button from '../../../src/components/common/elements/Button';
import Header from '../../../src/components/common/Header';
import Footer from '../../../src/components/common/Footer';
import MainContainer from '../../../src/components/common/elements/MainContainer';
import PaymentMethods from '../../../src/components/common/elements/PaymentMethods';
import SupportForm from '../../../src/components/common/elements/SupportForm';
import { HREF as PROFILE_HREF } from '../../profile';

const HREF = '/profile/payment-methods';
const TITLE = 'Moyens de paiement';

const ProfilePayments = ({ profile, cards }) => {
  return (
    <>
      <Head>
        <title key="title">YUPWEGO - {TITLE}</title>
      </Head>
      <Header profile={profile} />
      <MainContainer>
        <h1 className="sr-only">{TITLE}</h1>
        <Nav current={HREF} />
        <StripeAsyncProvider apiKey={process.env.STRIPE_PUBLIC_KEY}>
          <Elements>
            <PaymentMethods profile={profile} cards={cards} />
          </Elements>
        </StripeAsyncProvider>
        <Link href={PROFILE_HREF}>
          <Button href={PROFILE_HREF} secondary>
            Retour au profil
          </Button>
        </Link>
      </MainContainer>
      <SupportForm />
      <Footer />
    </>
  );
};

ProfilePayments.getInitialProps = async ({ req, res }) => {
  const profile = await user.profile(req, res);
  if (profile) {
    const opts = fetchOpts(req, res);
    const cards = await paymentMethodsApi.list(baseUrlOf(req), opts);
    return { profile, cards };
  } else {
    redirect(res, '/login?returnTo=' + req.url);
  }
};

ProfilePayments.propTypes = {
  profile: PropTypes.object.isRequired,
  cards: PropTypes.array.isRequired
};

export default ProfilePayments;
export { HREF };
